const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

// OAuth/MFA URLs carry tokens — every telemetry sink must scrub before sending
export function scrubTelemetryUrl(url: string) {
  return url
    .replace(
      /([?&])(token|code|state|session_id|login_hint)[^&]*/gi,
      '$1$2=REDACTED'
    )
    .replace(new RegExp(`([?&][^=&#]+=)${UUID}(?=[&#]|$)`, 'gi'), '$1:id')
    .replace(new RegExp(`/${UUID}(?=[/?#]|$)`, 'gi'), '/:id');
}
